import { useState } from 'react';
import { useLocation } from 'wouter';

const GALLERY_KEY = 'saiten-man-gallery';

function loadGallery() {
  try {
    return JSON.parse(localStorage.getItem(GALLERY_KEY) ?? '[]');
  } catch { return []; }
}

export default function GalleryScreen() {
  const [, setLocation] = useLocation();
  const [items, setItems] = useState(loadGallery);

  const deleteItem = (id) => {
    const next = items.filter((i) => i.id !== id);
    setItems(next);
    localStorage.setItem(GALLERY_KEY, JSON.stringify(next));
  };

  const clearAll = () => {
    setItems([]);
    localStorage.removeItem(GALLERY_KEY);
  };

  const download = (item) => {
    const a = document.createElement('a');
    a.href = item.dataUrl;
    a.download = `${item.name}-drawing.png`;
    a.click();
  };

  return (
    <div className="min-h-screen tv-bg-stripe flex flex-col items-center p-4 gap-4">
      <div className="w-full max-w-lg flex items-center justify-between mt-2">
        <div className="flex items-center gap-3">
          <button onClick={() => setLocation('/')} className="tv-btn tv-btn-white px-4 py-2 text-sm">← 戻る</button>
          <h1 className="tv-heading text-2xl">🖼 ギャラリー</h1>
        </div>
        {items.length > 0 && (
          <button onClick={clearAll} className="tv-btn tv-btn-white px-3 py-1 text-xs text-tv-red">
            全削除
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="tv-panel w-full max-w-lg p-8 flex flex-col items-center gap-2">
          <p className="font-body text-tv-ash text-center">保存した絵がありません</p>
          <p className="font-body text-xs text-tv-ash text-center mt-1">
            ホストが採点中に 💾 保存すると表示されます
          </p>
        </div>
      ) : (
        <div className="w-full max-w-lg flex flex-col gap-4 pb-6">
          {items.map((item) => (
            <div key={item.id} className="tv-panel p-4 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="text-2xl">{item.emoji}</span>
                  <div>
                    <p className="font-body font-bold">{item.name}</p>
                    <p className="font-body text-xs text-tv-ash">{item.prompt}</p>
                  </div>
                </div>
                <p className="font-body text-xs text-tv-ash">
                  {new Date(item.savedAt).toLocaleDateString('ja-JP')}
                </p>
              </div>
              <img
                src={item.dataUrl}
                alt={item.prompt}
                className="w-full border-2 border-tv-ash/30 rounded-lg"
              />
              <div className="flex gap-2 justify-end">
                <button
                  onClick={() => download(item)}
                  className="tv-btn tv-btn-white text-sm px-3 py-1"
                >
                  💾 ダウンロード
                </button>
                <button
                  onClick={() => deleteItem(item.id)}
                  className="tv-btn tv-btn-white text-sm px-3 py-1 text-tv-red"
                >
                  🗑 削除
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
